export const BILL_TYPES = [
    {
        id: "all",
        name: "bill-types.all",
        operationTypes: [6009, 6010, 6011, 6014]
    },
    {
        id: "base",
        name: "bill-types.base",
        operationTypes: [6009, 6010, 6011]
    },
    {
        id: "by-template",
        name: "bill-types.by-template",
        operationTypes: [6014]
    }
]
